import { createFileRoute } from '@tanstack/react-router';
import { ProspectsListPage } from '../../../features/crm';
import { usePageTitle } from '../../../lib/hooks';

export const Route = createFileRoute('/_auth/crm/prospects')({
  component: ProspectsRoute,
});

function ProspectsRoute() {
  usePageTitle('Prospects');
  return <ProspectsListPage />;
}
